import { JSX, createSignal, createMemo } from 'solid-js';
import { useBetSlipStore } from '@bz/betSlip';

import Empty from './Empty';

// 定义基础搜索项接口，T 必须扩展这个接口
interface SearchableItem {
  fullName?: string;
  aliasCurrencyName?: string;
  currencyCode: string;
  type?: string;
  currencyFullName?: string;
}

interface Props<T extends SearchableItem> {
  items: T[];
  filter?: (item: T) => boolean;
  children: (item: T) => JSX.Element;
  header?: JSX.Element;
  topExtraContent?: JSX.Element;
  topClass?: string;
  inputClass?: string;
  currency?: string;
  optionClass?: string;
  hasRadio?: boolean;
}

function SearchFilter<T extends SearchableItem>(props: Props<T>) {
  const [, , , , { getFastBetOptionsByCurrency }] = useBetSlipStore();

  const [searchTerm, setSearchTerm] = createSignal('');

  const visibled = createMemo(() => {
    const query = searchTerm().trim().toLowerCase();

    return new Set(
      !query
        ? props.items
        : props.items.filter((item) => {
            return (
              ((item.fullName?.toLowerCase().includes(query) ?? false) ||
                (item.currencyFullName?.toLowerCase().includes(query) ?? false) ||
                (item.aliasCurrencyName?.toLowerCase().includes(query) ?? false) ||
                item.currencyCode.toLowerCase().includes(query)) &&
              (props.filter ? props.filter(item) : true)
            );
          })
    );
  });

  const renderRadio = (item: T) => {
    return (
      <Radio
        class={cx(' justify-end', visibled().has(item) && 'bg-alpha-brand-brand-a5')}
        value={item}
        // bind={[value as any, setValue]}
      >
        {/* {props.format(item())} */}
      </Radio>
    );
  };

  return (
    <>
      <div class={cx('sticky z-10 left-0 -top-2 pt-3 px-3 pb-1 -mt-2 -mx-2 flex items-center', props.topClass)}>
        <Input
          value={searchTerm()}
          onChange={setSearchTerm}
          placeholder={t('Search')}
          prefix={<IconSearch class="size-4 mr-2" />}
          class={'h-10 flex-auto rounded-lg ' + props.inputClass}
        ></Input>
        {props.header}
      </div>
      {props.topExtraContent}
      <div class="overflow-y-auto flex-auto">
        <For each={props.items}>
          {(item) => {
            const hasMatch = () => item.currencyCode === props.currency;

            return item.currencyCode ? (
              <Closable>
                <SelectOption
                  class={cx(
                    'rounded-lg',
                    visibled().has(item) ? undefined : 'hidden',
                    hasMatch() && '!bg-alpha-neutral-autowhite-a10',
                    'hover:rounded-lg hover:!bg-layer5_5-card',
                    props.optionClass
                  )}
                  value={item}
                >
                  <div
                    class="flex items-center gap-4 w-full"
                    onClick={() => getFastBetOptionsByCurrency(item.currencyCode)}
                  >
                    <div class="flex-1 flex items-center gap-2 text-neutral-main1">{props.children(item)}</div>
                    <Show when={props.hasRadio}>
                      <div class="ml-4">{renderRadio(item)}</div>
                    </Show>
                  </div>
                </SelectOption>
              </Closable>
            ) : (
              <div class="mt-3 pl-3 text-sm text-neutral-main2 h-6">{(item as any).title || (item as any).label}</div>
            );
          }}
        </For>
      </div>
      <Toggle when={visibled().size === 0}>
        <Empty class="w-full !bg-[transparent] mt-4" imgName="emptyEmptyimg" />
      </Toggle>
    </>
  );
}

export default SearchFilter;
